"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosManagerOverrideRequestSchema = exports.APosPinValidateRequestSchema = exports.APosSessionSchema = exports.APosRoleGroupSchema = exports.APOS_PERMISSIONS = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
const timestamps_schema_1 = require("../../common/timestamps.schema");
// POS Permissions
exports.APOS_PERMISSIONS = [
    'void_own', 'void_any', 'discount_any', 'discount_preset', 'refund',
    'refund_no_receipt', 'cash_drop', 'register_open', 'register_close',
    'view_reports', 'view_held', 'price_override', 'open_drawer',
    'suspend_employee', 'hold_transaction', 'recall_transaction',
    'reprint_receipt', 'apply_coupon', 'loyalty_manual_adjust', 'training_mode',
    'device_settings',
];
// POS Role Group
exports.APosRoleGroupSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    roleGroupId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(50),
    description: zod_1.z.string().max(500).optional(),
    permissions: zod_1.z.array(zod_1.z.enum(exports.APOS_PERMISSIONS)).min(1),
    isDefault: zod_1.z.boolean().default(false),
    // Platform admin: when true the user's web user type becomes 'admin'
    // (settings, team management, all admin emails). Independent of POS admin.
    allowPlatformAdminAccess: zod_1.z.boolean().optional(),
    // POS admin: when true, privileged till actions (void/refund/price override…)
    // run without a manager-password prompt. Independent of platform admin.
    allowPosAdminAccess: zod_1.z.boolean().optional(),
    // AI Agent Cloud Desktop (MCP) access: when true, members of this role group
    // may connect the Claude Desktop MCP connector to read this business's data.
    // Independent of platform/POS admin — no other flag implies it.
    allowAiAgentMcpAccess: zod_1.z.boolean().optional(),
    // AI Inventory Alerts access: when true, members can view and manage AI-driven
    // inventory alert rules and alert history.
    allowAiInventoryAlertsAccess: zod_1.z.boolean().optional(),
    // AI Inventory Alert emails: when true, members receive email notifications
    // when AI inventory alerts are triggered.
    receiveAiInventoryAlertEmails: zod_1.z.boolean().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
// POS Session (for token revocation tracking)
exports.APosSessionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    sessionId: id_schema_1.EntityIdSchema,
    employeeId: id_schema_1.EntityIdSchema,
    registerId: id_schema_1.EntityIdSchema.nullable(),
    locationId: id_schema_1.EntityIdSchema,
    issuedAt: zod_1.z.number(),
    expiresAt: zod_1.z.number(),
    revokedAt: zod_1.z.number().nullable().default(null),
    revokeReason: zod_1.z.string().nullable().default(null),
    ttl: zod_1.z.number().optional(),
});
// PIN Validate Request
exports.APosPinValidateRequestSchema = zod_1.z.object({
    pin: zod_1.z.string().min(4).max(6).regex(/^\d+$/, 'PIN must be numeric'),
    locationId: id_schema_1.EntityIdSchema,
    tenantId: id_schema_1.TenantIdSchema,
});
// Manager Override Request
exports.APosManagerOverrideRequestSchema = zod_1.z.object({
    managerPin: zod_1.z.string().min(4).max(6).regex(/^\d+$/, 'PIN must be numeric'),
    action: zod_1.z.string().min(1),
    requiredPermission: zod_1.z.enum(exports.APOS_PERMISSIONS),
    context: zod_1.z.record(zod_1.z.unknown()).optional(),
});
//# sourceMappingURL=pos-auth.schema.js.map